import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import {
  PrimaryActionButton,
  CancelButton as UICancelButton,
} from "../../../../forms/ActionButtons";
import { ButtonSection } from "./components";

// Cancel leaves the panel, so it sits apart from the save action
export const CancelButton = styled(UICancelButton)`
  margin-right: auto;
`;

// A panel that can be left (onBack) never shows a disabled Update: with
// nothing to save its only action is Close, and once there are edits it
// offers Update, plus Cancel to leave them unsaved
const ReviewActions = ({ isBusy, isSaving, hasChanges, onUpdate, onBack }) => {
  if (onBack && !hasChanges) {
    return (
      <ButtonSection>
        <PrimaryActionButton onClick={onBack} disabled={isBusy}>
          Close
        </PrimaryActionButton>
      </ButtonSection>
    );
  }

  return (
    <ButtonSection>
      {onBack && (
        <CancelButton onClick={onBack} disabled={isBusy}>
          Cancel
        </CancelButton>
      )}
      <PrimaryActionButton
        onClick={onUpdate}
        disabled={isBusy || !hasChanges}
        isLoading={isSaving}
      >
        Update
      </PrimaryActionButton>
    </ButtonSection>
  );
};

ReviewActions.defaultProps = {
  isBusy: false,
  isSaving: false,
  hasChanges: false,
};

ReviewActions.propTypes = {
  isBusy: PropTypes.bool,
  isSaving: PropTypes.bool,
  hasChanges: PropTypes.bool,
  onUpdate: PropTypes.func.isRequired,
  onBack: PropTypes.func,
};

export default ReviewActions;
